import Logger from "@next/core-logger"
import {
    DEFAULT_TEMPLATE_HEADER_HEIGHTS,
    TEMPLATE_HEADER_HEIGHTS,
    SECURE_HEADER_HEIGHTS,
} from "../../templating/constants"

export const getUpperHeaderHeight = (
    template: string,
    staticHeaderBannerEnabled: boolean,
    showContentBanner: boolean,
    showBackToSiteBanner: boolean,
): {mobile: number; desktop: number} => {
    const foundHeights = TEMPLATE_HEADER_HEIGHTS[template]?.upperHeader
    const backToSiteBanner = () => {
        return showBackToSiteBanner ? foundHeights.back_to_site_banner : 0
    }

    if (!foundHeights) {
        Logger.warn(`Could not find header heights for ${template}, defaulting to backup header heights`)
        return DEFAULT_TEMPLATE_HEADER_HEIGHTS
    }

    if (staticHeaderBannerEnabled) {
        if (showContentBanner) {
            return {
                mobile: foundHeights.mobile_staticHeaderBanner + foundHeights.mobile_banner_offset + backToSiteBanner(),
                desktop: foundHeights.desktop_staticHeaderBanner + backToSiteBanner(),
            }
        }

        return {
            mobile: foundHeights.mobile_staticHeaderBanner + backToSiteBanner(),
            desktop: foundHeights.desktop_staticHeaderBanner + backToSiteBanner(),
        }
    }
    return {mobile: foundHeights.mobile + backToSiteBanner(), desktop: foundHeights.desktop + backToSiteBanner()}
}

export const getLowerHeaderHeight = (template: string): {mobile: number; desktop: number} => {
    const foundHeights = TEMPLATE_HEADER_HEIGHTS[template]?.lowerHeader

    if (!foundHeights) {
        Logger.warn(`Could not find header heights for ${template}, defaulting to backup header heights`)
        return DEFAULT_TEMPLATE_HEADER_HEIGHTS
    }

    return {mobile: foundHeights.mobile, desktop: foundHeights.desktop}
}

export const getMobileScrollHeight = (template: string, showBackToSiteBanner: boolean, isSecure: boolean): number => {
    if (isSecure) return SECURE_HEADER_HEIGHTS.mobile_scrollHeight

    const foundHeights = TEMPLATE_HEADER_HEIGHTS[template]

    if (!foundHeights) {
        Logger.warn(`Could not find header heights for ${template}, defaulting to backup header heights`)
        return DEFAULT_TEMPLATE_HEADER_HEIGHTS?.mobile_scrollHeight
    }

    return showBackToSiteBanner
        ? foundHeights.mobile_scrollHeight + foundHeights.upperHeader.back_to_site_banner
        : foundHeights.mobile_scrollHeight
}

export const getFullHeaderHeight = (
    template: string,
    staticHeaderBannerEnabled: boolean,
    showContentBanner: boolean,
    showBackToSiteBanner: boolean,
    isSecure: boolean,
): {mobile: number; desktop: number} => {
    if (isSecure) return {mobile: SECURE_HEADER_HEIGHTS.mobile, desktop: SECURE_HEADER_HEIGHTS.desktop}

    const upperHeader = getUpperHeaderHeight(
        template,
        staticHeaderBannerEnabled,
        showContentBanner,
        showBackToSiteBanner,
    )
    const lowerHeader = getLowerHeaderHeight(template)
    return {mobile: upperHeader.mobile + lowerHeader.mobile, desktop: upperHeader.desktop + lowerHeader.desktop}
}
